let mediaItems = [];

window.bindNoteFormEvents = () => {
  if (window.initRichTextEditors) window.initRichTextEditors(document.getElementById('default_modal') || document);

  const form = document.querySelector('#attachment-form');
  if (!form || form.dataset.mediaBound === 'true') return;

  form.dataset.mediaBound = 'true';
  mediaItems = readExistingMedia(form);
  const existingList = form.querySelector('#existing-attachments');
  if (existingList) existingList.hidden = true;
  renderMedia(form);
  form.addEventListener('submit', handleFormSubmit);

  const attachmentInput = form.querySelector('#attachments-input');
  if (attachmentInput) {
    attachmentInput.addEventListener('change', () => {
      const selected = Array.from(attachmentInput.files || []);
      if (!selected.length) return;

      mediaItems.push(mediaItemFromFile(selected[0]));
      attachmentInput.value = '';
      renderMedia(form);
    });
  }
}

const readExistingMedia = (form) => {
  return Array.from(form.querySelectorAll('#existing-attachments .existing-attachment')).map((element) => ({
    type: 'existing',
    identifier: element.querySelector('input[name="note[attachments][]"]')?.value || '',
    kind: element.dataset.kind || 'file',
    name: element.dataset.filename || '',
    previewUrl: element.dataset.previewUrl || ''
  })).filter((item) => item.identifier !== '');
}

const mediaItemFromFile = (file) => {
  const pdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
  const image = file.type.startsWith('image/');
  return {
    type: 'file',
    file,
    kind: pdf ? 'pdf' : (image ? 'image' : 'file'),
    name: file.name,
    previewUrl: image ? URL.createObjectURL(file) : '',
    previewIsBlob: image
  };
}

const renderMedia = (form) => {
  const container = form.querySelector('#attachments-list');
  const input = form.querySelector('#attachments-input');
  if (!container) return;

  container.innerHTML = '';
  if (!mediaItems.length) return;

  const removeLabel = input?.dataset.removeLabel || 'Remove';
  const rotateLabel = input?.dataset.rotateLabel || 'Rotate';
  const firstLabel = input?.dataset.firstLabel || '';
  const pdfIcon = input?.dataset.pdfIcon || '';
  const list = document.createElement('ul');

  mediaItems.forEach((item, index) => {
    const entry = document.createElement('li');
    entry.className = 'existing-attachment media-item';
    if (index === 0) entry.classList.add('is-first');

    const preview = document.createElement('div');
    preview.className = 'media-preview';

    if (item.kind === 'image' && item.previewUrl) {
      const image = document.createElement('img');
      image.src = item.previewUrl;
      image.alt = item.name;
      preview.appendChild(image);
    } else if (item.kind === 'pdf' && pdfIcon) {
      const image = document.createElement('img');
      image.src = pdfIcon;
      image.alt = 'PDF';
      image.className = 'media-preview__pdf';
      preview.appendChild(image);
      preview.appendChild(fileName(item.name));
    } else {
      const icon = document.createElement('i');
      icon.className = 'fas fa-file media-preview__pdf';
      icon.setAttribute('aria-hidden', 'true');
      preview.appendChild(icon);
      preview.appendChild(fileName(item.name));
    }

    entry.appendChild(preview);

    if (mediaItems.length > 1) {
      const rotate = document.createElement('button');
      rotate.type = 'button';
      rotate.className = 'media-item__rotate';
      rotate.setAttribute('aria-label', rotateLabel);
      rotate.innerHTML = '<i class="fas fa-redo" aria-hidden="true"></i>';
      rotate.addEventListener('click', () => {
        const [moved] = mediaItems.splice(index, 1);
        if (index === 0) mediaItems.push(moved);
        else mediaItems.unshift(moved);
        renderMedia(form);
      });
      entry.appendChild(rotate);

      if (index === 0 && firstLabel) {
        const first = document.createElement('span');
        first.className = 'media-item__first';
        first.textContent = firstLabel;
        entry.appendChild(first);
      }
    }

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'existing-attachment__remove';
    remove.setAttribute('aria-label', removeLabel);
    remove.innerHTML = '<i class="fas fa-times" aria-hidden="true"></i>';
    remove.addEventListener('click', () => {
      const [removed] = mediaItems.splice(index, 1);
      if (removed?.previewIsBlob) URL.revokeObjectURL(removed.previewUrl);
      renderMedia(form);
    });
    entry.appendChild(remove);
    list.appendChild(entry);
  });

  container.appendChild(list);
}

const fileName = (name) => {
  const label = document.createElement('span');
  label.className = 'media-preview__name';
  label.textContent = name.length > 28 ? `${name.slice(0, 25)}...` : name;
  return label;
}

const handleFormSubmit = async (event) => {
  event.preventDefault();
  const form = event.target;
  if (window.syncRichTextEditors) window.syncRichTextEditors(form, true);

  const requiredInput = form.querySelector('.rich-text-editor--required [data-rich-text-input]');
  if (requiredInput && !requiredInput.value.replace(/<[^>]+>/g, '').trim()) {
    const content = form.querySelector('.rich-text-editor--required [data-rich-text-content]');
    if (content) content.focus();
    return;
  }

  const formData = new FormData(form);
  formData.delete('note[attachments][]');
  if (!mediaItems.length) {
    formData.append('note[attachments][]', '');
  } else {
    mediaItems.forEach((item) => {
      if (item.type === 'existing') formData.append('note[attachments][]', item.identifier);
      else formData.append('note[attachments][]', item.file, item.file.name);
    });
  }
  const csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

  try {
    const response = await fetch(`${form.action}.js`, {
      method: form.method,
      body: formData,
      credentials: 'include',
      headers: {
        'X-CSRF-Token': csrf_token,
      }
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const scriptText = await response.text();
    executeResponseScript(scriptText);
  } catch (error) {
    console.error('Fetch error:', error);
  };
}

/**
 * This function is used to execute server-rendered scripts returned from AJAX calls.
 * Rails-ujs does this automatically for remote: true forms, but we need to do it manually
 * because we can't use remote: true for file uploads. The script returned from the server
 * is a js.erb template.
 * @param {string} scriptText - The text of the script to inject into the DOM
 */
const executeResponseScript = (scriptText) => {
  const script = document.createElement('script');

  script.setAttribute('nonce', cspNonce());
  script.text = scriptText;

  document.head.appendChild(script).parentNode.removeChild(script);
}

const cspNonce = () => {
  const metaTag = document.querySelector("meta[name=csp-nonce]")
  return nonce = metaTag && metaTag.content
}
